import { trace } from "@opentelemetry/api";
import { logSpan } from "../../../../helpers/loggingHelper";
import { isThereDataToBeSaved } from "../../helper/GridHelper";
import { calculateDifferenceInDeltaUnits } from "../../helper/xTablesHelper";
import { Row } from "../../interfaces/gridInterfaces";
import XTABLES_ACTION_TYPES from "../xTablesReduxActionTypes"
import xTablesStore from "../xTablesStore";
import { POST } from "../../../../service/axiosMethods";
import { formatCategorizeUpdateRows, formatgridChangesPerSaveSessionLocalVariable } from "../../../../helpers/loggerFormatHelper";
const tracer = trace.getTracer('xtables');

interface ChangedRows {
    add?: {addedRows:any[],belowNodeId:string};
    update?: any[];
    delete?: any[];
}

export interface gridRowChanges {
    add: Record<string, Row[]>;
    update: Record<string, Row>;
    delete: Record<string, Row>;
    addedRowsBelowNodeMap: Record<string, string>;
}


function findBelowNodeIdIndexAndInsertAboveIt(allNewRowsAboveThisNode:Row[],belowNodeId:string,row:Row){
    let index = allNewRowsAboveThisNode.findIndex(r=>r.id===belowNodeId)
    if(index===-1) index = 0
    allNewRowsAboveThisNode.splice(index,0,row)
}
function calculateNodeBelowThisNode (id:string,gridRef) :string{
    let node = gridRef.current.api.getRowNode(id);
    let belowNode = node.rowIndex?gridRef.current.api.getDisplayedRowAtIndex(node.rowIndex+1):gridRef.current.api.getDisplayedRowAtIndex(node.parent.rowIndex+1);
    return belowNode?.id ?? 'none'
}

function replaceDeletedNodewithBelowNodeInAddedRows(gridChangesPerSaveSessionLocalVariable:gridRowChanges,belowNodeId:string,deletedNodeId:string){
    let rowsAddedAboveDeletedNode = gridChangesPerSaveSessionLocalVariable.add[deletedNodeId]
    gridChangesPerSaveSessionLocalVariable.add[belowNodeId] = rowsAddedAboveDeletedNode
    delete gridChangesPerSaveSessionLocalVariable.add[deletedNodeId]
    
    rowsAddedAboveDeletedNode.forEach(row=>{
        gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id] = belowNodeId
    })
}
export const arrangeBySequence = (rows: Row[], gridRef) => {
    return rows
      .map(row => gridRef.current.api.getRowNode(row.id))
      .sort((a, b) => a.sourceRowIndex - b.sourceRowIndex)
      .map(node => node.data);
  };
  


export const categorizeAndStoreUpdatedRows =(updatedRows:ChangedRows , gridRef :any, spanRef:any )=>(dispatch)=>{
    let span:any ;
    if (spanRef) {
        span = spanRef;
    }
    else {
        span = tracer.startSpan('categorizeAndStoreUpdatedRows');
    }
    let functionFlow = ["categorizeAndStoreUpdatedRows started"]
    let gridChangesPerSaveSessionLocalVariable :gridRowChanges = xTablesStore.getState().gridReducer.gridChangesPerSaveSession
    if(updatedRows.delete){
        functionFlow.push("Inside delete")
        updatedRows.delete.forEach(row=>{
            if(gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id]){
                // find and update the row in the added rows
                let belowNode = gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id]
                let allNewRowsAboveThisNode : Row[] = gridChangesPerSaveSessionLocalVariable.add[belowNode] || []
                allNewRowsAboveThisNode = allNewRowsAboveThisNode.filter(r=>r.id!==row.id)
                if(allNewRowsAboveThisNode.length===0) delete gridChangesPerSaveSessionLocalVariable.add[belowNode]
                else gridChangesPerSaveSessionLocalVariable.add[belowNode] = allNewRowsAboveThisNode

                delete gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id]
            }
            else gridChangesPerSaveSessionLocalVariable.delete[row.id] = row
            if(gridChangesPerSaveSessionLocalVariable.update[row.id]){
                delete gridChangesPerSaveSessionLocalVariable.update[row.id]
            }
            if(gridChangesPerSaveSessionLocalVariable.add[row.id] ){
                //replace the deleted row with its below node inside added rows
                let isRowDragged = updatedRows.add && updatedRows.add.addedRows.find(r => r.id === row.id)
                if(!isRowDragged){
                    let rowsAddedAboveDeletedNode = gridChangesPerSaveSessionLocalVariable.add[row.id]
                    if(Array.isArray(rowsAddedAboveDeletedNode) && rowsAddedAboveDeletedNode.length>0){
                        let lastRowAddedAboveDeletedNode = rowsAddedAboveDeletedNode[rowsAddedAboveDeletedNode.length-1]
                        let belowNodeId = calculateNodeBelowThisNode(lastRowAddedAboveDeletedNode.id,gridRef)
                        replaceDeletedNodewithBelowNodeInAddedRows(gridChangesPerSaveSessionLocalVariable,belowNodeId,row.id)
                    }
                }
                
                
            }
        })
    }
    if (updatedRows.add) {
        functionFlow.push("Inside add")
        let { addedRows, belowNodeId } = updatedRows.add || {}
        if (belowNodeId) {
            let deepCopyBelowNodeId = JSON.parse(JSON.stringify(belowNodeId))
            if (gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap && gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[belowNodeId]) { }
            else {
                addedRows = addedRows?.reverse()
            }
            addedRows.forEach(row => {
                if (gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap && gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[belowNodeId]) 
                    belowNodeId = gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[belowNodeId]
                // if the row to add is in delete , then remove it from delete and do not add it   
                // let rowPresentInDelete = updatedRows.delete && updatedRows.delete.find(r => r.id === row.id)
                // if (gridChangesPerSaveSessionLocalVariable.delete[row.id] && !rowPresentInDelete) {
                //     // delete gridChangesPerSaveSessionLocalVariable.delete[row.id] 
                //     gridChangesPerSaveSessionLocalVariable.add[belowNodeId] = row
                // }
                // else {
                    let allNewRowsAboveThisNode: Row[] = gridChangesPerSaveSessionLocalVariable.add[belowNodeId] || []
                    if (belowNodeId != deepCopyBelowNodeId) findBelowNodeIdIndexAndInsertAboveIt(allNewRowsAboveThisNode, deepCopyBelowNodeId, row)
                    else allNewRowsAboveThisNode.unshift(row)
                    gridChangesPerSaveSessionLocalVariable.add[belowNodeId] = arrangeBySequence(allNewRowsAboveThisNode,gridRef)
                    gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id] = belowNodeId
                // }
            })
        }
    }
    if(updatedRows.update){
        functionFlow.push("Inside update")
        updatedRows.update.forEach(row=>{
            if(row){
                if(gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id]){
                    // find and update the row in the added rows
                    let belowNode = gridChangesPerSaveSessionLocalVariable.addedRowsBelowNodeMap[row.id]
                    let allNewRowsAboveThisNode : Row[] = gridChangesPerSaveSessionLocalVariable.add[belowNode] || []
                    let rowToUpdate = allNewRowsAboveThisNode.find(r=>r.id===row.id)
                    if(rowToUpdate) Object.assign(rowToUpdate,row)                    
                    // gridChangesPerSaveSessionLocalVariable.add[row.id] = [row]
                }
            if(!gridChangesPerSaveSessionLocalVariable.delete[row.id]){
                gridChangesPerSaveSessionLocalVariable.update[row.id] = row
            }
            }            
        })
    }
    console.log("gridChangesPerSaveSession",gridChangesPerSaveSessionLocalVariable)
    console.log("updatedRows",updatedRows)
    dispatch({type:XTABLES_ACTION_TYPES.SET_GRIDCHANGESPERSESSION, gridChangesPerSaveSession:gridChangesPerSaveSessionLocalVariable});
    if(isThereDataToBeSaved(gridChangesPerSaveSessionLocalVariable))
        {dispatch({ type: XTABLES_ACTION_TYPES.ENABLE_SAVE_BUTTON });}
    else{
        dispatch({ type: XTABLES_ACTION_TYPES.DISABLE_SAVE_BUTTON }) 
    }
    logSpan('categorizeAndStoreUpdatedRows-end-updatedRows-gridChangesPerSaveSessionLocalVariable', span?.spanContext(), "INFO",formatCategorizeUpdateRows(updatedRows), formatgridChangesPerSaveSessionLocalVariable(gridChangesPerSaveSessionLocalVariable));
    functionFlow.push("categorizeAndStoreUpdatedRows end");
    span?.setAttribute("categorizeAndStoreUpdatedRows-functionFlow", functionFlow);
    span?.end();
}
export const updateDeltaIfAnyBetweenSave =(obj1:gridRowChanges,obj2:gridRowChanges)=>dispatch =>{
    let {hasDifference,difference} = calculateDifferenceInDeltaUnits(obj1,obj2)
    dispatch({ type: XTABLES_ACTION_TYPES.SET_GRIDCHANGESPERSESSION, gridChangesPerSaveSession: difference })
    if(hasDifference) {dispatch({ type: XTABLES_ACTION_TYPES.ENABLE_SAVE_BUTTON })}
    else dispatch({ type: XTABLES_ACTION_TYPES.DISABLE_SAVE_BUTTON })
}

export const setIsUpdating = (isUpdating:any) => async (dispatch) => {
    dispatch({ type: XTABLES_ACTION_TYPES.SET_IS_UPDATING, isUpdating: isUpdating })
}

export const updateTemplate =async(currentSelectedSheet:any, user:string )=>{
                        const templateData = {
                            template_id: currentSelectedSheet.template_id,
                            updated_at: new Date().toISOString(),
                            updated_by: user
                        };
                        const res = await POST(`/template/update`, templateData);
                        return res                
}